<template>
    <div class="c-form-item" :class="[{'c-form-item--horizontal': horizontal}, customClass ? customClass : '', fluid ? 'c-form-item--fluid':'']">
        <v-label :custom-class="[customLabelClass, !horizontal ? 'c-block' : '']" :id="name">
            <slot name="label"></slot>
        </v-label>
        <textarea v-if="autofocus"
                :class="`c-form-element c-input c-textarea`"
                :name="name"
                :id="name"
                :cols="cols"
                :rows="rows"
                :value="value"
                v-focus
                @input="updateValue($event.target.value)"
                :disabled="readOnly">
        </textarea>
        <textarea v-else
                :class="`c-form-element c-input c-textarea`"
                :name="name"
                :id="name"
                :cols="cols"
                :rows="rows"
                :value="value"
                @input="updateValue($event.target.value)"
                :disabled="readOnly">
        </textarea>
    </div>
</template>

<script>
    import VLabel from './Label.vue'

    export default {
        directives: {
            focus: {
                inserted(el) {
                    el.focus()
                }
            }
        },
        props: {
            'name': String,
            'custom-class': String,
            'custom-label-class': String,
            'value': String,
            fluid: {type: Boolean, default: true},
            'cols': String,
            'rows': String,
            'autofocus': {type: Boolean, default: false},
            horizontal: {type: Boolean, default: true},
            readOnly: {type: Boolean, default: false}
        },
        components: {
            VLabel
        },
        methods: {
            updateValue(value) {
                this.$emit('input', value);
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/form/Textarea.vue